import { localStorageOrNull } from './storage'

export type KeyView = 'cards' | 'table'

const STORAGE_KEY = 'apiKeys.view'

export function readKeyView(storage: Storage | null = localStorageOrNull()): KeyView {
  try {
    return storage?.getItem(STORAGE_KEY) === 'table' ? 'table' : 'cards'
  } catch {
    return 'cards'
  }
}

export function writeKeyView(view: KeyView, storage: Storage | null = localStorageOrNull()): void {
  try {
    storage?.setItem(STORAGE_KEY, view)
  } catch {
    // Blocked storage: the choice lasts until the page reloads.
  }
}
